import { useContext } from 'react';
import { UnseenCountContext } from './UnseenCountContext';
export const useUnseenCountText = () => {
  const unseen = useContext(UnseenCountContext);
  if (unseen) {
    const unseenCountText = `${unseen > 99 ? '99+' : unseen}`;
    return {
      unseenCountText,
      notificationsButtonCountBadge: unseenCountText
    };
  }
  return {
    unseenCountText: '',
    notificationsButtonCountBadge: 'none'
  };
};